module.exports = __webpack_public_path__ + "static/img/MIX2500_8.fc0e71f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MIX2500_8.png
// module id = p3Zl
// module chunks = 1